const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function normalizeEmail(value: string): string {
  return value.trim().normalize("NFC").toLowerCase();
}

export function isValidEmail(value: string): boolean {
  const normalized = normalizeEmail(value);
  return normalized.length <= 254 && EMAIL_PATTERN.test(normalized);
}

export function encodeEmailKey(email: string): string {
  const bytes = new TextEncoder().encode(normalizeEmail(email));
  let binary = "";
  for (const byte of bytes) binary += String.fromCharCode(byte);
  return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
}

export function decodeEmailKey(value: string): string {
  if (!/^[A-Za-z0-9_-]{4,512}$/.test(value)) throw new Error("Invalid email key");
  try {
    const padded = value.replace(/-/g, "+").replace(/_/g, "/") + "===".slice((value.length + 3) % 4);
    const binary = atob(padded);
    const bytes = Uint8Array.from(binary, (char) => char.charCodeAt(0));
    const email = normalizeEmail(new TextDecoder("utf-8", { fatal: true }).decode(bytes));
    if (!isValidEmail(email)) throw new Error("Invalid email key");
    return email;
  } catch {
    throw new Error("Invalid email key");
  }
}

export function statusToSheet(status: string): string {
  if (status === "confirmed") return "Confirmed";
  if (status === "declined") return "Declined";
  return "No answer";
}

export function statusFromSheet(value: unknown): "pending" | "confirmed" | "declined" {
  const normalized = String(value ?? "").trim().toLowerCase();
  if (["confirmed", "confirm", "yes", "attending", "katılıyor", "katiliyorum"].includes(normalized)) return "confirmed";
  if (["declined", "decline", "no", "not attending", "katılmıyor", "katilamiyorum"].includes(normalized)) return "declined";
  return "pending";
}

export function safeText(value: unknown, max: number): string {
  return String(value ?? "").trim().normalize("NFC").slice(0, max);
}
